import $ from 'jquery';
import gsap from "gsap/dist/gsap";
import ScrollTrigger from "gsap/dist/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.arrive(".header", {existing: true}, function (){

  setInterval(function(){ 
    // toggle the class every 
    $('.title-studio, .title-tenda, .title-studio-mobile, .title-tenda-mobile').addClass('animate');
  },1000);

  gsap.to('.title-first', {
    scrollTrigger: {
      trigger: '.title-first',
      start: 'bottom bottom',
      end: 'top +=100',
      scrub: 1,
    },
    x: '50%',
    y: 0,
    scale: 1.3,
    duration: 2
  });

  gsap.to('.title-second', {
    scrollTrigger: {
      trigger: '.title-second',
      start: 'bottom bottom',
      end: 'top +=100',
      scrub: 1,
    },
    x: '-65%',
    y: '14vw',
    scale: 1.3,
    duration: 2
  });

  
})